import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Button, Tooltip } from 'react-wot-bootstrap'

import ButtonSimple from 'components/ButtonSimple/ButtonSimple'

import {
    ANNOUNCEMENT_VIEW_BUTTON_EDIT,
    ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE,
    ANNOUNCEMENT_VIEW_BUTTON_DELETE,
    ANNOUNCEMENT_VIEW_BUTTON_CREATE,
    ANNOUNCEMENT_VIEW_BUTTON_EDIT_TOOLTIP,
    ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE_TOOLTIP,
    ANNOUNCEMENT_VIEW_BUTTON_DELETE_TOOLTIP,
    ANNOUNCEMENT_VIEW_BUTTON_CREATE_TOOLTIP,
    ANNOUNCEMENT_VIEW_BUTTON_CREATE_DISABLED_TOOLTIP,
} from '../../translations'

import { ANNOUNCEMENT_MODE, TOOLTIP_IDS } from '../../constants'

import styles from './Footer.scss'

export const FooterViewControls = (props) => {
    const {
        onChangeMode,
        isAnnouncementsLimitReached,
        disabledEdit,
        disabledArchive,
        disabledDelete,
        disabledCreate,
    } = props

    const creationButtonTooltip = isAnnouncementsLimitReached ?
        ANNOUNCEMENT_VIEW_BUTTON_CREATE_DISABLED_TOOLTIP :
        ANNOUNCEMENT_VIEW_BUTTON_CREATE_TOOLTIP

    const baseClassNames = classNames(
        styles.base,
        styles.base__view,
    )

    const buttonClassNames = classNames(
        styles.button,
        styles.button__right,
    )

    return (
        <div className={baseClassNames}>
            <div className={styles.button}>
                <ButtonSimple
                    isDisabled={disabledEdit}
                    tooltipId={TOOLTIP_IDS.BUTTON_EDIT}
                    onClick={() => onChangeMode(ANNOUNCEMENT_MODE.EDIT)}
                >
                    <span className={styles.buttonText}>
                        {ANNOUNCEMENT_VIEW_BUTTON_EDIT}
                    </span>
                </ButtonSimple>
                <Tooltip id={TOOLTIP_IDS.BUTTON_EDIT}>
                    {ANNOUNCEMENT_VIEW_BUTTON_EDIT_TOOLTIP}
                </Tooltip>
            </div>
            <div className={styles.button}>
                <ButtonSimple
                    isDisabled={disabledArchive}
                    tooltipId={TOOLTIP_IDS.BUTTON_ARCHIVE}
                    onClick={() => onChangeMode(ANNOUNCEMENT_MODE.ARCHIVE)}
                >
                    <span className={styles.buttonText}>
                        {ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE}
                    </span>
                </ButtonSimple>
                <Tooltip id={TOOLTIP_IDS.BUTTON_ARCHIVE}>
                    {ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE_TOOLTIP}
                </Tooltip>
            </div>
            <div className={styles.button}>
                <ButtonSimple
                    isDisabled={disabledDelete}
                    tooltipId={TOOLTIP_IDS.BUTTON_DELETE}
                    onClick={() => onChangeMode(ANNOUNCEMENT_MODE.DELETE)}
                >
                    <span className={styles.buttonText}>
                        {ANNOUNCEMENT_VIEW_BUTTON_DELETE}
                    </span>
                </ButtonSimple>
                <Tooltip id={TOOLTIP_IDS.BUTTON_DELETE}>
                    {ANNOUNCEMENT_VIEW_BUTTON_DELETE_TOOLTIP}
                </Tooltip>
            </div>
            <div className={buttonClassNames}>
                <Button
                    isDisabled={disabledCreate || isAnnouncementsLimitReached}
                    tooltipId={TOOLTIP_IDS.BUTTON_CREATE}
                    onClick={() => onChangeMode(ANNOUNCEMENT_MODE.CREATE)}
                >
                    <span className={styles.buttonText}>
                        {ANNOUNCEMENT_VIEW_BUTTON_CREATE}
                    </span>
                </Button>
                <Tooltip id={TOOLTIP_IDS.BUTTON_CREATE}>
                    {creationButtonTooltip}
                </Tooltip>
            </div>
        </div>
    )
}

FooterViewControls.propTypes = {
    onChangeMode: PropTypes.func.isRequired,
    isAnnouncementsLimitReached: PropTypes.bool.isRequired,
    disabledEdit: PropTypes.bool,
    disabledArchive: PropTypes.bool,
    disabledDelete: PropTypes.bool,
    disabledCreate: PropTypes.bool,
}

FooterViewControls.defaultProps = {
    disabledEdit: false,
    disabledArchive: false,
    disabledDelete: false,
    disabledCreate: false,
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/components/Footer/FooterViewControls.jsx